import React from 'react'
import { View, StyleSheet, SafeAreaView } from 'react-native'
import { Modal, KeyboardView, Button } from '../../../../components'
import PropTypes from 'prop-types'
import { changePasswordSelector } from '../../../../redux/profile/userInformationSelector'
import { changePasswordUserInformation } from '../../../../redux/profile/userInformationActions'

import { Formik } from 'formik'
import * as Yup from 'yup'
import { useSelector, useDispatch } from 'react-redux'
import InputFormik from '../../../../components/InputFormik'

const validationSchema = Yup.object({
  newPassword: Yup.string()
    .notOneOf([Yup.ref('currentPassword'), null], 'The current password cannot be the same as the previous one')
    .required('New password is required'),
  repeatPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords don\'t match')
    .required('Repeat password is required'),
  currentPassword: Yup.string()
    .required('Current password is required')
})

const PasswordModal = ({ open, onClose }) => {
  const { changePasswordLoading } = useSelector(changePasswordSelector)
  const dispatch = useDispatch()

  const onSubmit = ({ currentPassword, newPassword }) =>
    dispatch(changePasswordUserInformation({
      password: currentPassword,
      new_password: newPassword
    }, onClose))

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Change Password'
    >
      <KeyboardView>
        <SafeAreaView style={{ flex: 1 }}>
          <Formik
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            initialValues={{ newPassword: '', repeatPassword: '', currentPassword: '' }}
          >
            {({ values, touched, errors, setFieldValue, handleSubmit }) => (
              <>
                <View>
                  <InputFormik
                    name='newPassword'
                    label='New Password'
                    onChange={setFieldValue}
                    value={values?.newPassword || ''}
                    error={touched.newPassword && errors.newPassword}
                    placeholder='New Password'
                    icon='Security'
                    revealPassword
                    testID='profileChangePasswordNewInput'
                    accessibilityLabel='profileChangePasswordNewInput'
                  />
                </View>
                <View>
                  <InputFormik
                    name='repeatPassword'
                    label='Repeat Password'
                    onChange={setFieldValue}
                    value={values?.repeatPassword || ''}
                    error={touched.repeatPassword && errors.repeatPassword}
                    placeholder='Repeat Password'
                    icon='Security'
                    revealPassword
                    testID='profileChangePasswordRepeatInput'
                    accessibilityLabel='profileChangePasswordRepeatInput'
                  />
                </View>

                <View>
                  <InputFormik
                    name='currentPassword'
                    label='Enter current password'
                    onChange={setFieldValue}
                    value={values?.currentPassword || ''}
                    error={touched.currentPassword && errors.currentPassword}
                    placeholder='Enter current password'
                    icon='Security'
                    revealPassword
                    testID='profileChangePasswordCurrentInput'
                    accessibilityLabel='profileChangePasswordCurrentInput'
                  />
                </View>
                <View style={styles.buttonContainer}>
                  <Button
                    title='Change Password'
                    onPress={handleSubmit}
                    loading={changePasswordLoading}
                    testID='profileChangePasswordButton'
                    accessibilityLabel='profileChangePasswordButton'
                  />
                </View>
              </>
            )}
          </Formik>
        </SafeAreaView>
      </KeyboardView>
    </Modal>
  )
}

const styles = StyleSheet.create({
  buttonContainer: {
    marginTop: 20,
    width: '100%'
  }
})

PasswordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default PasswordModal
